<div class="row mb-3">
  <div class="col-12 d-flex justify-content-between">
    <h1 class="text-size-important mb-2">Order: {{ 'trade.create.header.' + direction | transloco }}</h1>
    @if (marketPlace && quoteTime) {
      <div class="text-size-small text-right">
        {{ marketPlace }}
        <br />
        {{ (quoteTime | isQuoteOld) ? (quoteTime | date: 'dd.MM.yy') : (quoteTime | date: 'HH:mm:ss') }}
      </div>
    }
  </div>
</div>
